import icon0 from '../../shared/icons/4g.svg';
import icon1 from '../../shared/icons/5g.svg';
import icon2 from '../../shared/icons/add.svg';
import icon3 from '../../shared/icons/address-book.svg';
import icon4 from '../../shared/icons/ai-robot.svg';
import icon5 from '../../shared/icons/airplay.svg';
import icon6 from '../../shared/icons/alarm-off.svg';
import icon7 from '../../shared/icons/alarm.svg';
import icon8 from '../../shared/icons/alert-filled.svg';
import icon9 from '../../shared/icons/alert.svg';
import icon10 from '../../shared/icons/arrow-down.svg';
import icon11 from '../../shared/icons/arrow-left.svg';
import icon12 from '../../shared/icons/arrow-right.svg';
import icon13 from '../../shared/icons/arrow-subdirectory.svg';
import icon14 from '../../shared/icons/arrow-up.svg';
import icon15 from '../../shared/icons/attachment.svg';
import icon16 from '../../shared/icons/b2b-customer.svg';
import icon17 from '../../shared/icons/bag.svg';
import icon18 from '../../shared/icons/bar-chart.svg';
import icon19 from '../../shared/icons/basketball.svg';
import icon20 from '../../shared/icons/battery.svg';
import icon21 from '../../shared/icons/blood-pressure.svg';
import icon22 from '../../shared/icons/broadband.svg';
import icon23 from '../../shared/icons/broken-phone.svg';
import icon24 from '../../shared/icons/bulb.svg';
import icon25 from '../../shared/icons/business-continuity.svg';
import icon26 from '../../shared/icons/business-intelligence.svg';
import icon27 from '../../shared/icons/calendar.svg';
import icon28 from '../../shared/icons/camera.svg';
import icon29 from '../../shared/icons/card-view.svg';
import icon30 from '../../shared/icons/care.svg';
import icon31 from '../../shared/icons/cart.svg';
import icon32 from '../../shared/icons/cast.svg';
import icon33 from '../../shared/icons/chat-robot.svg';
import icon34 from '../../shared/icons/chat.svg';
import icon35 from '../../shared/icons/check-circle-filled.svg';
import icon36 from '../../shared/icons/check-circle.svg';
import icon37 from '../../shared/icons/checkmark.svg';
import icon38 from '../../shared/icons/chevron-down.svg';
import icon39 from '../../shared/icons/chevron-left.svg';
import icon40 from '../../shared/icons/chevron-right.svg';
import icon41 from '../../shared/icons/chevron-up.svg';
import icon42 from '../../shared/icons/child-1.svg';
import icon43 from '../../shared/icons/child-2.svg';
import icon44 from '../../shared/icons/close-circle.svg';
import icon45 from '../../shared/icons/close.svg';
import icon46 from '../../shared/icons/cloud.svg';
import icon47 from '../../shared/icons/coffee.svg';
import icon48 from '../../shared/icons/connected-building.svg';
import icon49 from '../../shared/icons/connected.svg';
import icon50 from '../../shared/icons/conversation.svg';
import icon51 from '../../shared/icons/copy.svg';
import icon52 from '../../shared/icons/core-router.svg';
import icon53 from '../../shared/icons/credit-card.svg';
import icon54 from '../../shared/icons/customer-dialogue.svg';
import icon55 from '../../shared/icons/daas-device.svg';
import icon56 from '../../shared/icons/data-transfer.svg';
import icon57 from '../../shared/icons/delete.svg';
import icon58 from '../../shared/icons/delivery.svg';
import icon59 from '../../shared/icons/desktop.svg';
import icon60 from '../../shared/icons/devices.svg';
import icon61 from '../../shared/icons/dislike.svg';
import icon62 from '../../shared/icons/doc.svg';
import icon63 from '../../shared/icons/document-doc.svg';
import icon64 from '../../shared/icons/document-edit.svg';
import icon65 from '../../shared/icons/document-pdf.svg';
import icon66 from '../../shared/icons/document-ppt.svg';
import icon67 from '../../shared/icons/dot.svg';
import icon68 from '../../shared/icons/download.svg';
import icon69 from '../../shared/icons/dsl-hub.svg';
import icon70 from '../../shared/icons/edit.svg';
import icon71 from '../../shared/icons/education.svg';
import icon72 from '../../shared/icons/efficiency.svg';
import icon73 from '../../shared/icons/email.svg';
import icon74 from '../../shared/icons/end-user.svg';
import icon75 from '../../shared/icons/entertainment.svg';
import icon76 from '../../shared/icons/environment.svg';
import icon77 from '../../shared/icons/error-filled.svg';
import icon78 from '../../shared/icons/error.svg';
import icon79 from '../../shared/icons/esim-simcard.svg';
import icon80 from '../../shared/icons/euro.svg';
import icon81 from '../../shared/icons/excel.svg';
import icon82 from '../../shared/icons/external.svg';
import icon83 from '../../shared/icons/face-id.svg';
import icon84 from '../../shared/icons/facebook.svg';
import icon85 from '../../shared/icons/fiber.svg';
import icon86 from '../../shared/icons/film.svg';
import icon87 from '../../shared/icons/filter.svg';
import icon88 from '../../shared/icons/fingerprint.svg';
import icon89 from '../../shared/icons/focus.svg';
import icon90 from '../../shared/icons/folder-copy.svg';
import icon91 from '../../shared/icons/folder-new.svg';
import icon92 from '../../shared/icons/folder.svg';
import icon93 from '../../shared/icons/food.svg';
import icon94 from '../../shared/icons/fraud.svg';
import icon95 from '../../shared/icons/games.svg';
import icon96 from '../../shared/icons/getting-started.svg';
import icon97 from '../../shared/icons/gif.svg';
import icon98 from '../../shared/icons/graph.svg';
import icon99 from '../../shared/icons/grid-view.svg';
import icon100 from '../../shared/icons/handshake.svg';
import icon101 from '../../shared/icons/headphones.svg';
import icon102 from '../../shared/icons/heart-filled.svg';
import icon103 from '../../shared/icons/heart.svg';
import icon104 from '../../shared/icons/help.svg';
import icon105 from '../../shared/icons/helppi.svg';
import icon106 from '../../shared/icons/home-care.svg';
import icon107 from '../../shared/icons/home-installation.svg';
import icon108 from '../../shared/icons/home.svg';
import icon109 from '../../shared/icons/image.svg';
import icon110 from '../../shared/icons/industry.svg';
import icon111 from '../../shared/icons/infinite.svg';
import icon112 from '../../shared/icons/info-filled.svg';
import icon113 from '../../shared/icons/info.svg';
import icon114 from '../../shared/icons/instagram.svg';
import icon115 from '../../shared/icons/internet.svg';
import icon116 from '../../shared/icons/invoice.svg';
import icon117 from '../../shared/icons/job-search.svg';
import icon118 from '../../shared/icons/kontantkort.svg';
import icon119 from '../../shared/icons/laptop.svg';
import icon120 from '../../shared/icons/late-payment.svg';
import icon121 from '../../shared/icons/letter.svg';
import icon122 from '../../shared/icons/like.svg';
import icon123 from '../../shared/icons/link.svg';
import icon124 from '../../shared/icons/linkedin.svg';
import icon125 from '../../shared/icons/list-view.svg';
import icon126 from '../../shared/icons/lock-closed.svg';
import icon127 from '../../shared/icons/lock-open.svg';
import icon128 from '../../shared/icons/login.svg';
import icon129 from '../../shared/icons/logout.svg';
import icon130 from '../../shared/icons/map.svg';
import icon131 from '../../shared/icons/media-content.svg';
import icon132 from '../../shared/icons/megaphone.svg';
import icon133 from '../../shared/icons/menu.svg';
import icon134 from '../../shared/icons/microphone.svg';
import icon135 from '../../shared/icons/minus.svg';
import icon136 from '../../shared/icons/mms.svg';
import icon137 from '../../shared/icons/moisture.svg';
import icon138 from '../../shared/icons/money-back.svg';
import icon139 from '../../shared/icons/money-euro.svg';
import icon140 from '../../shared/icons/money-krone.svg';
import icon141 from '../../shared/icons/more-horizontal.svg';
import icon142 from '../../shared/icons/more-vertical.svg';
import icon143 from '../../shared/icons/music.svg';
import icon144 from '../../shared/icons/mute.svg';
import icon145 from '../../shared/icons/network.svg';
import icon146 from '../../shared/icons/new-contact.svg';
import icon147 from '../../shared/icons/new-group.svg';
import icon148 from '../../shared/icons/news.svg';
import icon149 from '../../shared/icons/offering.svg';
import icon150 from '../../shared/icons/offshore.svg';
import icon151 from '../../shared/icons/optimization.svg';
import icon152 from '../../shared/icons/org-chart.svg';
import icon153 from '../../shared/icons/parental-guide.svg';
import icon154 from '../../shared/icons/password-invisible.svg';
import icon155 from '../../shared/icons/password-visible.svg';
import icon156 from '../../shared/icons/pay-monthly.svg';
import icon157 from '../../shared/icons/pay-once.svg';
import icon158 from '../../shared/icons/payment-success.svg';
import icon159 from '../../shared/icons/pebble.svg';
import icon160 from '../../shared/icons/people-hub.svg';
import icon161 from '../../shared/icons/people.svg';
import icon162 from '../../shared/icons/phone-recycling.svg';
import icon163 from '../../shared/icons/phone-ringing.svg';
import icon164 from '../../shared/icons/phone.svg';
import icon165 from '../../shared/icons/pie-chart.svg';
import icon166 from '../../shared/icons/plane.svg';
import icon167 from '../../shared/icons/play.svg';
import icon168 from '../../shared/icons/player-settings.svg';
import icon169 from '../../shared/icons/plus-minus.svg';
import icon170 from '../../shared/icons/plus.svg';
import icon171 from '../../shared/icons/police.svg';
import icon172 from '../../shared/icons/portal.svg';
import icon173 from '../../shared/icons/premises-datacenter.svg';
import icon174 from '../../shared/icons/premises-large.svg';
import icon175 from '../../shared/icons/premises-medium.svg';
import icon176 from '../../shared/icons/premises-small.svg';
import icon177 from '../../shared/icons/premises.svg';
import icon178 from '../../shared/icons/present.svg';
import icon179 from '../../shared/icons/press-button.svg';
import icon180 from '../../shared/icons/price.svg';
import icon181 from '../../shared/icons/print.svg';
import icon182 from '../../shared/icons/pulse.svg';
import icon183 from '../../shared/icons/question-filled.svg';
import icon184 from '../../shared/icons/question.svg';
import icon185 from '../../shared/icons/rack.svg';
import icon186 from '../../shared/icons/record.svg';
import icon187 from '../../shared/icons/recycle.svg';
import icon188 from '../../shared/icons/refill-card.svg';
import icon189 from '../../shared/icons/register.svg';
import icon190 from '../../shared/icons/remote-control.svg';
import icon191 from '../../shared/icons/repair.svg';
import icon192 from '../../shared/icons/report.svg';
import icon193 from '../../shared/icons/reservation.svg';
import icon194 from '../../shared/icons/reverse.svg';
import icon195 from '../../shared/icons/roaming.svg';
import icon196 from '../../shared/icons/router.svg';
import icon197 from '../../shared/icons/satellite.svg';
import icon198 from '../../shared/icons/save.svg';
import icon199 from '../../shared/icons/savings.svg';
import icon200 from '../../shared/icons/search.svg';
import icon201 from '../../shared/icons/secure-device.svg';
import icon202 from '../../shared/icons/secured-1.svg';
import icon203 from '../../shared/icons/secured-2.svg';
import icon204 from '../../shared/icons/send.svg';
import icon205 from '../../shared/icons/sense-car.svg';
import icon206 from '../../shared/icons/server.svg';
import icon207 from '../../shared/icons/service-device.svg';
import icon208 from '../../shared/icons/service-supervision.svg';
import icon209 from '../../shared/icons/services.svg';
import icon210 from '../../shared/icons/settings.svg';
import icon211 from '../../shared/icons/share.svg';
import icon212 from '../../shared/icons/shopping.svg';
import icon213 from '../../shared/icons/shuffle.svg';
import icon214 from '../../shared/icons/signature.svg';
import icon215 from '../../shared/icons/simcard.svg';
import icon216 from '../../shared/icons/skip-back-10sec.svg';
import icon217 from '../../shared/icons/skip-back-30sec.svg';
import icon218 from '../../shared/icons/skip-forward-10sec.svg';
import icon219 from '../../shared/icons/skip-forward-30sec.svg';
import icon220 from '../../shared/icons/slow-wifi.svg';
import icon221 from '../../shared/icons/smart-wifi.svg';
import icon222 from '../../shared/icons/smartphone.svg';
import icon223 from '../../shared/icons/smartwatch.svg';
import icon224 from '../../shared/icons/smiley-happy.svg';
import icon225 from '../../shared/icons/smiley-sad.svg';
import icon226 from '../../shared/icons/sms.svg';
import icon227 from '../../shared/icons/snapchat.svg';
import icon228 from '../../shared/icons/snowflake.svg';
import icon229 from '../../shared/icons/sorter.svg';
import icon230 from '../../shared/icons/speedometer.svg';
import icon231 from '../../shared/icons/spell-check.svg';
import icon232 from '../../shared/icons/star-filled.svg';
import icon233 from '../../shared/icons/star.svg';
import icon234 from '../../shared/icons/stop.svg';
import icon235 from '../../shared/icons/store.svg';
import icon236 from '../../shared/icons/stream.svg';
import icon237 from '../../shared/icons/suitcase.svg';
import icon238 from '../../shared/icons/summary.svg';
import icon239 from '../../shared/icons/support.svg';
import icon240 from '../../shared/icons/sustainability.svg';
import icon241 from '../../shared/icons/switch.svg';
import icon242 from '../../shared/icons/sync.svg';
import icon243 from '../../shared/icons/table-view.svg';
import icon244 from '../../shared/icons/tablet.svg';
import icon245 from '../../shared/icons/tag.svg';
import icon246 from '../../shared/icons/time.svg';
import icon247 from '../../shared/icons/trade-phone.svg';
import icon248 from '../../shared/icons/trailer.svg';
import icon249 from '../../shared/icons/transfer.svg';
import icon250 from '../../shared/icons/tv-next.svg';
import icon251 from '../../shared/icons/tv-pause.svg';
import icon252 from '../../shared/icons/tv-play.svg';
import icon253 from '../../shared/icons/tv-previous.svg';
import icon254 from '../../shared/icons/tv.svg';
import icon255 from '../../shared/icons/twitter.svg';
import icon256 from '../../shared/icons/undo.svg';
import icon257 from '../../shared/icons/upload.svg';
import icon258 from '../../shared/icons/usb.svg';
import icon259 from '../../shared/icons/user-admin.svg';
import icon260 from '../../shared/icons/vcard.svg';
import icon261 from '../../shared/icons/video-conference.svg';
import icon262 from '../../shared/icons/video.svg';
import icon263 from '../../shared/icons/voice-switch.svg';
import icon264 from '../../shared/icons/voicemail.svg';
import icon265 from '../../shared/icons/volume.svg';
import icon266 from '../../shared/icons/wallet.svg';
import icon267 from '../../shared/icons/wallplug.svg';
import icon268 from '../../shared/icons/warning.svg';
import icon269 from '../../shared/icons/weather.svg';
import icon270 from '../../shared/icons/wireless-off.svg';
import icon271 from '../../shared/icons/wireless.svg';
import icon272 from '../../shared/icons/world-alert.svg';
import icon273 from '../../shared/icons/world-off.svg';
import icon274 from '../../shared/icons/world-question.svg';
import icon275 from '../../shared/icons/world.svg';
import icon276 from '../../shared/icons/youtube.svg';
import icon277 from '../../shared/icons/zoom.svg';

export default {
  '4g': icon0,
  '5g': icon1,
  add: icon2,
  'address-book': icon3,
  'ai-robot': icon4,
  airplay: icon5,
  'alarm-off': icon6,
  alarm: icon7,
  'alert-filled': icon8,
  alert: icon9,
  'arrow-down': icon10,
  'arrow-left': icon11,
  'arrow-right': icon12,
  'arrow-subdirectory': icon13,
  'arrow-up': icon14,
  attachment: icon15,
  'b2b-customer': icon16,
  bag: icon17,
  'bar-chart': icon18,
  basketball: icon19,
  battery: icon20,
  'blood-pressure': icon21,
  broadband: icon22,
  'broken-phone': icon23,
  bulb: icon24,
  'business-continuity': icon25,
  'business-intelligence': icon26,
  calendar: icon27,
  camera: icon28,
  'card-view': icon29,
  care: icon30,
  cart: icon31,
  cast: icon32,
  'chat-robot': icon33,
  chat: icon34,
  'check-circle-filled': icon35,
  'check-circle': icon36,
  checkmark: icon37,
  'chevron-down': icon38,
  'chevron-left': icon39,
  'chevron-right': icon40,
  'chevron-up': icon41,
  'child-1': icon42,
  'child-2': icon43,
  'close-circle': icon44,
  close: icon45,
  cloud: icon46,
  coffee: icon47,
  'connected-building': icon48,
  connected: icon49,
  conversation: icon50,
  copy: icon51,
  'core-router': icon52,
  'credit-card': icon53,
  'customer-dialogue': icon54,
  'daas-device': icon55,
  'data-transfer': icon56,
  delete: icon57,
  delivery: icon58,
  desktop: icon59,
  devices: icon60,
  dislike: icon61,
  doc: icon62,
  'document-doc': icon63,
  'document-edit': icon64,
  'document-pdf': icon65,
  'document-ppt': icon66,
  dot: icon67,
  download: icon68,
  'dsl-hub': icon69,
  edit: icon70,
  education: icon71,
  efficiency: icon72,
  email: icon73,
  'end-user': icon74,
  entertainment: icon75,
  environment: icon76,
  'error-filled': icon77,
  error: icon78,
  'esim-simcard': icon79,
  euro: icon80,
  excel: icon81,
  external: icon82,
  'face-id': icon83,
  facebook: icon84,
  fiber: icon85,
  film: icon86,
  filter: icon87,
  fingerprint: icon88,
  focus: icon89,
  'folder-copy': icon90,
  'folder-new': icon91,
  folder: icon92,
  food: icon93,
  fraud: icon94,
  games: icon95,
  'getting-started': icon96,
  gif: icon97,
  graph: icon98,
  'grid-view': icon99,
  handshake: icon100,
  headphones: icon101,
  'heart-filled': icon102,
  heart: icon103,
  help: icon104,
  helppi: icon105,
  'home-care': icon106,
  'home-installation': icon107,
  home: icon108,
  image: icon109,
  industry: icon110,
  infinite: icon111,
  'info-filled': icon112,
  info: icon113,
  instagram: icon114,
  internet: icon115,
  invoice: icon116,
  'job-search': icon117,
  kontantkort: icon118,
  laptop: icon119,
  'late-payment': icon120,
  letter: icon121,
  like: icon122,
  link: icon123,
  linkedin: icon124,
  'list-view': icon125,
  'lock-closed': icon126,
  'lock-open': icon127,
  login: icon128,
  logout: icon129,
  map: icon130,
  'media-content': icon131,
  megaphone: icon132,
  menu: icon133,
  microphone: icon134,
  minus: icon135,
  mms: icon136,
  moisture: icon137,
  'money-back': icon138,
  'money-euro': icon139,
  'money-krone': icon140,
  'more-horizontal': icon141,
  'more-vertical': icon142,
  music: icon143,
  mute: icon144,
  network: icon145,
  'new-contact': icon146,
  'new-group': icon147,
  news: icon148,
  offering: icon149,
  offshore: icon150,
  optimization: icon151,
  'org-chart': icon152,
  'parental-guide': icon153,
  'password-invisible': icon154,
  'password-visible': icon155,
  'pay-monthly': icon156,
  'pay-once': icon157,
  'payment-success': icon158,
  pebble: icon159,
  'people-hub': icon160,
  people: icon161,
  'phone-recycling': icon162,
  'phone-ringing': icon163,
  phone: icon164,
  'pie-chart': icon165,
  plane: icon166,
  play: icon167,
  'player-settings': icon168,
  'plus-minus': icon169,
  plus: icon170,
  police: icon171,
  portal: icon172,
  'premises-datacenter': icon173,
  'premises-large': icon174,
  'premises-medium': icon175,
  'premises-small': icon176,
  premises: icon177,
  present: icon178,
  'press-button': icon179,
  price: icon180,
  print: icon181,
  pulse: icon182,
  'question-filled': icon183,
  question: icon184,
  rack: icon185,
  record: icon186,
  recycle: icon187,
  'refill-card': icon188,
  register: icon189,
  'remote-control': icon190,
  repair: icon191,
  report: icon192,
  reservation: icon193,
  reverse: icon194,
  roaming: icon195,
  router: icon196,
  satellite: icon197,
  save: icon198,
  savings: icon199,
  search: icon200,
  'secure-device': icon201,
  'secured-1': icon202,
  'secured-2': icon203,
  send: icon204,
  'sense-car': icon205,
  server: icon206,
  'service-device': icon207,
  'service-supervision': icon208,
  services: icon209,
  settings: icon210,
  share: icon211,
  shopping: icon212,
  shuffle: icon213,
  signature: icon214,
  simcard: icon215,
  'skip-back-10sec': icon216,
  'skip-back-30sec': icon217,
  'skip-forward-10sec': icon218,
  'skip-forward-30sec': icon219,
  'slow-wifi': icon220,
  'smart-wifi': icon221,
  smartphone: icon222,
  smartwatch: icon223,
  'smiley-happy': icon224,
  'smiley-sad': icon225,
  sms: icon226,
  snapchat: icon227,
  snowflake: icon228,
  sorter: icon229,
  speedometer: icon230,
  'spell-check': icon231,
  'star-filled': icon232,
  star: icon233,
  stop: icon234,
  store: icon235,
  stream: icon236,
  suitcase: icon237,
  summary: icon238,
  support: icon239,
  sustainability: icon240,
  switch: icon241,
  sync: icon242,
  'table-view': icon243,
  tablet: icon244,
  tag: icon245,
  time: icon246,
  'trade-phone': icon247,
  trailer: icon248,
  transfer: icon249,
  'tv-next': icon250,
  'tv-pause': icon251,
  'tv-play': icon252,
  'tv-previous': icon253,
  tv: icon254,
  twitter: icon255,
  undo: icon256,
  upload: icon257,
  usb: icon258,
  'user-admin': icon259,
  vcard: icon260,
  'video-conference': icon261,
  video: icon262,
  'voice-switch': icon263,
  voicemail: icon264,
  volume: icon265,
  wallet: icon266,
  wallplug: icon267,
  warning: icon268,
  weather: icon269,
  'wireless-off': icon270,
  wireless: icon271,
  'world-alert': icon272,
  'world-off': icon273,
  'world-question': icon274,
  world: icon275,
  youtube: icon276,
  zoom: icon277,
};
